export function GraphicAsset1({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="94"
      height="127"
      viewBox="0 0 94 127"
      fill="none"
    >
      <path
        d="M20.3178 81.3025C22.1096 82.0084 23.5984 84.592 23.6116 87.0628L23.6775 98.0045L15.7196 94.9126C13.9277 94.2067 12.4389 91.623 12.4257 89.1382L12.3599 78.1964L20.3178 81.3025Z"
        fill="#FFFF00"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M36.2204 81.6278C36.2073 79.1571 34.7184 76.5593 32.9266 75.8675L24.9687 72.7615L12.3599 78.1971L20.3178 81.3031C22.1096 82.009 23.5984 84.5927 23.6116 87.0634L23.6775 98.0052L36.2863 92.5696L36.2204 81.6278Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M12.0971 31.8738L12.3738 78.1963L4.41584 75.0902C2.61082 74.3843 1.13524 71.7866 1.10889 69.33L0.884854 31.9867C0.871679 29.516 2.33419 28.076 4.13921 28.7819L12.0971 31.8879V31.8738Z"
        fill="#FFFF00"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M12.0967 31.8747L24.6923 26.4391L24.969 72.7616L12.3602 78.1972L12.0967 31.8747Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M16.7348 23.3325C16.1287 23.0925 15.549 23.1066 15.0615 23.3184L2.45264 28.754C2.94013 28.5422 3.50669 28.5422 4.12593 28.7681L12.0838 31.8741L24.6927 26.4385L16.7348 23.3325Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M12.0967 31.8736L12.0309 20.9318C12.0177 18.447 13.4802 17.0069 15.272 17.6987L23.2299 20.8048L23.2958 31.7607C23.3089 34.2314 21.8465 35.6715 20.0547 34.9797L12.0967 31.8736Z"
        fill="#FFFF00"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M23.2303 20.8059L35.8391 15.3704L36.7087 27.0039C36.7877 28.1051 36.0631 29.3334 35.0881 29.7146L22.1499 34.7549C22.1499 34.7549 23.3357 34.2184 23.3093 31.7759L23.2435 20.8201L23.2303 20.8059Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M27.87 12.2635C27.264 12.0235 26.6974 12.0376 26.2099 12.2494L13.6011 17.685C14.0886 17.4732 14.6551 17.4732 15.2612 17.6991L23.2191 20.8052L35.8279 15.3696L27.87 12.2635Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M53.5607 17.2336C55.3657 17.9395 56.8414 20.5373 56.8677 22.9939L56.9336 33.9357L23.2442 20.7914L23.1783 9.84968C23.1651 7.37896 24.6276 5.93888 26.4326 6.6448L53.5739 17.2336H53.5607Z"
        fill="#FFFF00"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M69.4618 17.572C69.4487 15.1013 67.9598 12.5035 66.1548 11.8117L39.0135 1.22286C38.4074 0.98285 37.8278 0.996976 37.3403 1.20875L24.7314 6.64432C25.2189 6.43255 25.7854 6.43254 26.4047 6.65844L53.546 17.2472C55.351 17.9532 56.8266 20.5509 56.853 23.0076L56.9189 33.9493L69.5277 28.5137L69.4618 17.572Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M57.3685 111.149L57.4345 122.105C57.4477 124.576 55.9852 126.016 54.1801 125.324L27.0389 114.736C25.2339 114.03 23.7582 111.432 23.7319 108.975L23.666 98.0334L57.3554 111.164L57.3685 111.149Z"
        fill="#FFFF00"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M69.9775 105.713L57.3686 111.149L57.4346 122.104C57.4346 123.742 56.8021 124.928 55.8535 125.338L68.4624 119.902C69.411 119.493 70.0566 118.307 70.0434 116.669L69.9775 105.713Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M23.6777 98.019L36.2865 92.5834L69.9759 105.713L57.3671 111.149L23.6777 98.019Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M64.8778 37.0558C66.6697 37.7617 68.1585 40.3454 68.1717 42.8302L68.2375 53.772L60.2796 50.6659C58.4878 49.96 56.999 47.3763 56.9858 44.9056L56.9199 33.9497L64.8778 37.0558Z"
        fill="#FFFF00"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M80.7805 37.3937C80.7673 34.9088 79.2785 32.3251 77.4867 31.6192L69.5288 28.5132L56.9199 33.9488L64.8778 37.0548C66.6697 37.7607 68.1585 40.3444 68.1717 42.8292L68.2375 53.771L80.8464 48.3354L80.7805 37.3937Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M58.896 96.9731L71.5048 91.5375C71.9923 91.3257 72.5589 91.3257 73.1649 91.5516L60.5561 96.9872C59.95 96.7472 59.3835 96.7613 58.896 96.9731Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M68.5009 100.095L68.5668 111.037C68.5799 113.522 67.1175 114.962 65.3257 114.27L57.3677 111.164L57.3018 100.208C57.2887 97.7372 58.7512 96.2971 60.543 96.9889L68.5009 100.095Z"
        fill="#FFFF00"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M81.1103 94.6592L68.5014 100.095L68.5673 111.037C68.5673 112.688 67.935 113.874 66.9863 114.284L79.5952 108.848C80.5438 108.439 81.1893 107.239 81.1761 105.601L81.1103 94.6592Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M60.5425 96.9883L73.1513 91.5527L81.1092 94.6588L68.5004 100.094L60.5425 96.9883Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M76.1963 56.8775C77.9881 57.5834 79.4769 60.1671 79.4901 62.6378L79.7141 99.981C79.7272 102.452 78.2647 103.892 76.4729 103.2L68.515 100.094L68.2383 53.7715L76.1963 56.8775Z"
        fill="#FFFF00"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
      <path
        d="M92.0852 57.2019C92.072 54.7312 90.5832 52.1334 88.7913 51.4416L80.8334 48.3356L68.2246 53.7712L76.1825 56.8772C77.9744 57.5831 79.4632 60.1668 79.4763 62.6375L79.7003 99.9807C79.7003 101.618 79.0679 102.804 78.1192 103.214L90.7281 97.7782C91.6767 97.3688 92.3223 96.1828 92.3091 94.5451L92.0852 57.2019Z"
        fill="#000001"
        stroke="#FFFF00"
        strokeWidth="1.41184"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export function GraphicAsset2({ className = '' }) {
  return (
    <svg
      className={className}
      width="124"
      height="124"
      viewBox="0 0 124 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <path
          id="Vector"
          d="M122.666 18.9288C123.018 24.3642 98.4406 45.9341 67.7508 67.0926C37.077 88.251 11.9235 100.991 11.5555 95.5553C11.2035 90.12 35.7809 68.55 66.4548 47.4087C97.1446 26.2503 122.298 13.5107 122.65 18.946L122.666 18.9288Z"
          fill="#FFFF00"
          stroke="black"
          strokeWidth="1.71462"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M112.585 2.14318L122.49 18.3464C120.186 14.5742 95.8643 27.1253 66.4546 47.3921C35.7807 68.5506 11.2033 90.1033 11.5553 95.5387C11.5553 95.7616 11.6353 95.9673 11.7313 96.1217L1.82669 79.9185C1.73069 79.747 1.66671 79.5584 1.65071 79.3355C1.29869 73.9002 25.8761 52.3302 56.55 31.1889C85.9437 10.9221 110.281 -1.62899 112.585 2.14318Z"
          fill="#FFFF00"
          stroke="black"
          strokeWidth="1.71462"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M23.3157 81.0167L13.1712 65.0365C5.82673 71.8607 1.50645 77.0389 1.65046 79.3364C1.65046 79.5594 1.73044 79.7651 1.82645 79.9194L11.731 96.1226C11.635 95.9511 11.5711 95.7625 11.5551 95.5396C11.411 93.2077 15.8114 87.9438 23.2998 81.0167H23.3157Z"
          fill="black"
        />
      </g>
    </svg>
  )
}

export function GraphicAssetSquare({ c = 'white', className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="23"
      viewBox="0 0 21 23"
      fill="none"
    >
      <path
        d="M20.9544 7.14423L6.79297 0.473389L0.567719 15.6484L14.7291 22.3192L20.9544 7.14423Z"
        fill={c}
      />
    </svg>
  )
}
